export const company = {
  legalName: "CÔNG TY TNHH VẬT TƯ Y TẾ GIA BẢO",
  brandName: "GIA BAO MEDICAL",
  address: "326 đường 406, Ấp 2, Xã Củ Chi, TP Hồ Chí Minh",
  taxCode: "0316144978",
  email: "ytegiabao@gmail.com",
  website: "www.giabaomedical.com",
  phone: "0986361999",
  slogan: "Place of your trust",
  logoPath: "/brand/gia-bao-medical-logo.jpg"
} as const;
